import { FaFire } from "react-icons/fa";
import {
  bagIcon,
  balsamiqIcon,
  bookIcon,
  confluenceIcon,
  contactIcon,
  drawIcon,
  freeIcon,
  interviewIcon,
  jiraIcon,
  ledIcon,
  miroIcon,
  mysqlIcon,
  playIcon,
  sqlIcon,
  suitcaseIcon,
  trelloIcon,
  userIcon,
  vIcon,
  visio,
  workIcon,
  writeIcon,
  fastTrackInstruct,
  figmaLogo,
  sql,
  github,
  powerBI,
  excel
} from "../images";

export const CARD_FIRST_COLUMN = [
  {
    firstColumn: [
      {
        icon: workIcon,
        title: "For a complete novice",
        text: "Join our beginner-friendly program and start your journey with confidence. No experience needed – get started today!",
      },
      {
        icon: freeIcon,
        title: "Start Free",
        text: "Try out our first week for free when you register.  You will get exclusive access to the week 1 live sessions.",
      },
      {
        icon: writeIcon,
        title: "On-the-Job Support",
        text: "Never walk alone. Eliminate impostor syndrome on the job. Our tutors and alumni will work with you to deliver excellence on the job.",
      },
    ],
  },
  {
    secondColumn: [
      {
        icon: bagIcon,
        title: "Internship",
        text: "Get real world experience with our internship program. Work on unique client projects across different verticals to boost your resume and job search.",
      },
      {
        icon: sqlIcon,
        title: "Personalized Career Coaching",
        text: "Get access to 1-on-1 resume clinic and interview prep to stand out from the crowd and distinguish yourself with potential employers.",
      },
      {
        icon: userIcon,
        title: "BONUS: Scrum Master & Product Owner Training",
        text: "Diversify your skillset and Elevate your career with bonus modules on scrum and product ownership taught by our expert instructors.",
      },
    ],
  },
];

export const CARD_SECOND_COLUMN = [
  {
    firstColumn: [
      {
        icon: null,
        title: "🔁 Feeling Stuck in Your Career? Start Fresh Here",
        text: "You don’t need a tech background or fancy job title to start learning Business Analysis. If you’re looking for a real career shift or want to upskill for better job opportunities, this is your zero-risk starting point."
      },
      {
        icon: null,
        title: "🎁 Risk-Free Start.  Show up & Start with confidence.",
        text: "No credit card, no pressure to join a bootcamp. Join this live session, ask your questions, and see if Business Analysis is right for you—before making any decisions. You’ve got nothing to lose and everything to explore."
      },
      {
        icon: null,
        title: "🎯 Job-Focused Live Training—No fluffs",
        text: "You’ll join live sessions led by an experienced Business Analyst who teaches only what matters for real-world roles. Get practical skills, personal feedback, and guidance in real time—so you can stat your BA journey confidently."
      },
    ],
  },
  {
    secondColumn: [
      {
        icon: interviewIcon,
        title: "Hands-on Projects",
        text: "Gain practical experience with real-world projects and case studies."
      },
      {
        icon: suitcaseIcon,
        title: "Job-ready Skills",
        text: "Acquire the skills needed to excel in product management roles."
      },
      {
        icon: playIcon,
        title: "Networking Opportunities",
        text: "Connect with industry professionals and fellow learners to expand your network."
      },
    ],
  },
];

export const CARD_THIRD_COLUMN = [
  {
    firstColumn: [
      {
        icon: bookIcon,
        title: "Master SQL from scratch",
        text: "Build a strong foundation in SQL, from basics to advanced techniques, and gain the skills to stand out in a data-driven world."
      },
      {
        icon: FaFire,
        title: "Confidence through practice",
        text: "Work on real-world datasets, master query optimization, and solve data challenges guided by industry experts in interactive sessions."
      },
      {
        icon: fastTrackInstruct,
        title: "Accelerate Your Career",
        text: "Position yourself for high-demand roles in Business Analysis, Business Intelligence, and tech. Transform your career in just 4 weeks!"
      },
    ],
  },
  {
    secondColumn: [
      {
        icon: interviewIcon,
        title: "Hands-on Projects",
        text: "Gain practical experience with real-world projects and case studies."
      },
      {
        icon: suitcaseIcon,
        title: "Job-ready Skills",
        text: "Acquire the skills needed to excel in product management roles."
      },
      {
        icon: playIcon,
        title: "Networking Opportunities",
        text: "Connect with industry professionals and fellow learners to expand your network."
      },
    ],
  },
];
export const CARD_THIRD_COLUMN1 = [
  {
    firstColumn: [
      {
        icon: suitcaseIcon,
        title: "Business Analysis ",
        text: "Regular fee: $2500 CAD "
      },
      {
        icon: FaFire,
        title: "Data Analysis",
        text: "Regular fee: $2500 CAD "
      },
      {
        icon: fastTrackInstruct,
        title: "Project Management ",
        text: "Regular fee: $2500 CAD "
      },
    ],
  },
  {
    secondColumn: [
      {
        icon: interviewIcon,
        title: "Hands-on Projects",
        text: "Gain practical experience with real-world projects and case studies."
      },
      {
        icon: suitcaseIcon,
        title: "Job-ready Skills",
        text: "Acquire the skills needed to excel in product management roles."
      },
      {
        icon: playIcon,
        title: "Networking Opportunities",
        text: "Connect with industry professionals and fellow learners to expand your network."
      },
    ],
  },
];



export const COURSE_TOOLS = [jiraIcon, confluenceIcon, miroIcon, figmaLogo]
export const COURSE_TOOLS2 = [sql, excel, powerBI, github]
export const COURSE_TOOLS3 = [jiraIcon, confluenceIcon, miroIcon, excel]
export const COURSE_TOOLS1 = [jiraIcon, confluenceIcon, balsamiqIcon, miroIcon, figmaLogo, drawIcon, visio, trelloIcon]

